import { CodeNode, CodeHighlightNode } from '@lexical/code';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { ListNode, ListItemNode } from '@lexical/list';
import { QuoteNode } from '@lexical/rich-text';
import { TextNode } from 'lexical';
import './nodes/browser/HashPlaceholderNode/HashPlaceholderComponent.mjs';
import './nodes/browser/ImageNode/ImageComponent.mjs';
import FallbackCodeNode from './nodes/headless/FallbackNode/code.mjs';
import FallbackCodeHighlightNode from './nodes/headless/FallbackNode/code-highlight.mjs';
import './nodes/headless/TimePresetNode/TimePresetNode.mjs';

const BUILTIN_NODES = [
  TextNode,
  LinkNode,
  AutoLinkNode,
  QuoteNode,
  ListNode,
  ListItemNode
];
const DEFAULT_NODE_LIST_EDIT_MODE = [
  ...BUILTIN_NODES,
  FallbackCodeNode,
  FallbackCodeHighlightNode
];
const DEFAULT_NODE_LIST_READ_MODE = [
  ...BUILTIN_NODES,
  /**
   * 기존에 생성된 데이터 중 flexical에서 지원하지 않는 포맷이 들어간 데이터가 있음.
   * 해당 데이터를 읽을 수는 있도록 읽기 모드에서는 관련 node를 추가해준다.
   */
  CodeNode,
  CodeHighlightNode,
  ListItemNode
];
const DEFAULT_BLOCK_TYPES = [
  "bullet",
  "code",
  "number",
  "paragraph",
  "quote"
];

export { DEFAULT_BLOCK_TYPES, DEFAULT_NODE_LIST_EDIT_MODE, DEFAULT_NODE_LIST_READ_MODE };
//# sourceMappingURL=constant.base.mjs.map
